export default __webpack_public_path__ + "static/media/tetra_t.6fa0fdcd.obj";